import React from "react";
import TeamCard from "./TeamCard";
import p1 from "../images/p1.png";
import p2 from "../images/p2.png";

const Team = ({ color, ref }) => {
  const data = [
    {
      img: p1,
      name: "Nilesh Kumar Gupta",
      title: "Founder & CEO",
    },
    {
      img: p2,
      name: "Kanak Raj Tomar",
      title: "Co-Founder & CMO",
    },
  ];
  return (
    <div id="team" className="flex flex-col mt-[50px] base-wrapper">
      <h2 className="md:text-[92px] mb-[100px] sm:text-[55px] text-[45px] font-[700]">
        Our Team
      </h2>
      <div className="grid md:grid-cols-3 grid-cols-1 gap-[50px] ">
        {data.map((e) => {
          return (
            <TeamCard
              img={e.img}
              name={e.name}
              title={e.title}
              key={e}
              color={color}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Team;
